exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3-EqE1hWnAgJGakMD1j1Mm{height:300px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#263238}._3yQIRbskIZcrheO4VtFHH2{display:block}._1OXnUpps7-qhPm-wq4Gr5J{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._1OXnUpps7-qhPm-wq4Gr5J,.PwO6RTJ9OIiFMVC5cwRzn{display:-webkit-box;display:-ms-flexbox;display:flex}.PwO6RTJ9OIiFMVC5cwRzn{max-width:600px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:15px 20px 20px;background-color:#eceff1;box-shadow:1px 1px 1px 1px rgba(0,0,0,.05);border-radius:.5em;margin:1pc;margin:1rem}._2EW1cHjg4o3er_I-rumzLb{text-align:center;color:#37474f;font-size:.8em}", ""]);

// exports
exports.locals = {
	"headerRow": "_3-EqE1hWnAgJGakMD1j1Mm",
	"logo": "_3yQIRbskIZcrheO4VtFHH2",
	"body": "_1OXnUpps7-qhPm-wq4Gr5J",
	"card": "PwO6RTJ9OIiFMVC5cwRzn",
	"footer": "_2EW1cHjg4o3er_I-rumzLb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./website/Application.css
// module id = 200
// module chunks = 0